import React from 'react';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';
import IndividualInformHeader from '../../components/individualInformHeader/individualInformHeader';
import { PredictiveMatrixBlockSelfcare } from './pagePredictiveMatrixSelfcare';
import {
    SELFCARE_MATRIX_CRITICAL_THRESHOLD,
    SELFCARE_MATRIX_PROTECTIVE_THRESHOLD,
    getVisibleSelfcareMatrices,
} from './selfcarePredictiveMatrices';

const PagePredictiveMatricesSelfcare = ({
    selectedEvaluation,
    individualResult,
    orgLogo,
    startPageNumber,
}) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const visibleMatrices = getVisibleSelfcareMatrices(individualResult);
    if (visibleMatrices.length === 0) return null;

    return (
        <>
            {visibleMatrices.map((item, idx) => {
                const pageNumber = startPageNumber + idx;
                return (
                    <div key={`matrix-page-${item.def.id}`} className="pdf-page internal-page">
                        <div className="internal-page-content" style={backgroundStyle}>
                            <AutoSizeTitle text={selectedEvaluation?.evl_title} />
                            <div className="internal-page-info internal-page-info-individual">
                                <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />
                                <div className="selfcare-matrix-title">Análisis Predictivo Matriz 2x2</div>

                                {idx === 0 && (
                                    <>
                                        <div className="selfcare-matrix-intro">
                                            En seguridad, el riesgo rara vez se explica por un solo factor. Muchas condiciones se combinan. Por eso, además de puntajes por dimensión, este informe incluye matrices 2x2 para identificar combinaciones que aumentan o reducen la probabilidad de error humano.
                                            <br />
                                            <br />
                                            <b>Importante:</b> Esta matriz no evalúa a la persona. Evalúa la condición actual en la que estás hoy. Esa condición puede cambiar y mejorar con acciones concretas.
                                        </div>

                                        <div className="selfcare-matrix-legend">
                                            <div className="selfcare-matrix-legend-col">
                                                <div className="selfcare-matrix-tier">
                                                    <span className="selfcare-matrix-dot" style={{ backgroundColor: '#43A047' }} />
                                                    <span className="selfcare-matrix-range">≥{SELFCARE_MATRIX_PROTECTIVE_THRESHOLD} y ≥{SELFCARE_MATRIX_PROTECTIVE_THRESHOLD}</span>
                                                    <span className="selfcare-matrix-tier-name">ZONA PROTECTORA</span>
                                                </div>
                                                <div className="selfcare-matrix-tier">
                                                    <span className="selfcare-matrix-dot" style={{ backgroundColor: '#FDD835' }} />
                                                    <span className="selfcare-matrix-range">Uno ≥{SELFCARE_MATRIX_PROTECTIVE_THRESHOLD}, otro &lt;{SELFCARE_MATRIX_PROTECTIVE_THRESHOLD}</span>
                                                    <span className="selfcare-matrix-tier-name">ZONA MIXTA</span>
                                                </div>
                                                <div className="selfcare-matrix-tier">
                                                    <span className="selfcare-matrix-dot" style={{ backgroundColor: '#FB8C00' }} />
                                                    <span className="selfcare-matrix-range">Ambos &lt;{SELFCARE_MATRIX_PROTECTIVE_THRESHOLD}, al menos uno ≥{SELFCARE_MATRIX_CRITICAL_THRESHOLD}</span>
                                                    <span className="selfcare-matrix-tier-name">ZONA MIXTA ELEVADA</span>
                                                </div>
                                                <div className="selfcare-matrix-tier">
                                                    <span className="selfcare-matrix-dot" style={{ backgroundColor: '#E53935' }} />
                                                    <span className="selfcare-matrix-range">&lt;{SELFCARE_MATRIX_CRITICAL_THRESHOLD} y &lt;{SELFCARE_MATRIX_CRITICAL_THRESHOLD}</span>
                                                    <span className="selfcare-matrix-tier-name">ZONA CRÍTICA</span>
                                                </div>
                                            </div>
                                            <div className="selfcare-matrix-legend-text">
                                                <div className="selfcare-matrix-legend-text-title">
                                                    La matriz cruza dos dimensiones en escala 0 a 100. Alto = condición más protectora.
                                                </div>
                                                <ul className="selfcare-matrix-legend-list">
                                                    <li>
                                                        <b>Protectora</b>: ambas dimensiones en rango seguro.
                                                    </li>
                                                    <li>
                                                        <b>Mixta</b>: una dimensión está segura y la otra requiere atención.
                                                    </li>
                                                    <li>
                                                        <b>Mixta elevada</b>: ambas dimensiones requieren atención combinada.
                                                    </li>
                                                    <li>
                                                        <b>Crítica</b>: ambas dimensiones se ubican en rango crítico.
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </>
                                )}

                                <div className="selfcare-matrix-page-blocks">
                                    <PredictiveMatrixBlockSelfcare
                                        individualResult={individualResult}
                                        matrixDef={item.def}
                                        xScore={item.x}
                                        yScore={item.y}
                                        compact={idx > 0}
                                    />
                                </div>
                            </div>
                            <div className="internal-page-number">{pageNumber}</div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default PagePredictiveMatricesSelfcare;
